var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  viewBox: "0 0 24 24",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.9799 16.5604C4.7299 16.5604 4.4699 16.4604 4.2799 16.2704C3.8899 15.8804 3.8799 15.2504 4.2799 14.8604L11.3599 7.70039C11.5499 7.51039 11.7999 7.40039 12.0699 7.40039C12.3399 7.40039 12.5899 7.51039 12.7799 7.70039L19.7399 14.8104C20.1299 15.2004 20.1199 15.8404 19.7199 16.2204C19.3299 16.6104 18.6899 16.6004 18.3099 16.2004L12.0599 9.81039L5.6899 16.2404C5.4899 16.4404 5.2399 16.5404 4.9799 16.5404V16.5604Z",
  fill: "inherit"
})));
export default SvgChevronUp;